"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = getStoreRenderArgs;

var _getRenderArgs = _interopRequireDefault(require("./getRenderArgs"));

var _createStoreRouterObject = _interopRequireDefault(require("./utils/createStoreRouterObject")); // This function returns a promise. It doesn't need to be an async function
// because it doesn't use the promise's value.


function getStoreRenderArgs(_ref) {
  var store = _ref.store,
      _ref$getFound = _ref.getFound,
      getFound = _ref$getFound === void 0 ? function (_ref2) {
    var found = _ref2.found;
    return found;
  } : _ref$getFound,
      matchContext = _ref.matchContext,
      resolver = _ref.resolver;
  var router = (0, _createStoreRouterObject["default"])(store);
  var match = getFound(store.getState()).resolvedMatch;
  return (0, _getRenderArgs["default"])(router, {
    match: match,
    matchContext: matchContext,
    resolver: resolver
  });
}

module.exports = exports.default;